import { Component, Input, OnInit } from "@angular/core";
import { Severity } from "src/app/models/api/governance/violationRule.model";
import { LabelsProviderPipe } from "src/app/pipes/labels-provider/labels-provider.pipe";
import { StatusLabelEnum } from "../../status-label/status-label.component";
import { SidePanelService } from "../../../features/side-panel/services/side-panel.service";
import { ICardField } from "src/app/models/viewModels/cardModel";

export interface RelatedViolationCardComponentInput {
    violationName: string;
    ruleCategory: string;
    firstSeen: string;
    violationId: string;
    statusLabel: StatusLabelEnum;
    severity: Severity;
    integrationId: string;
}

@Component({
    selector: "app-related-violation-card",
    templateUrl: "./related-violation-card.component.html",
    styleUrls: ["./related-violation-card.component.scss"],
})
export class RelatedViolationCardComponent implements OnInit {
    @Input() public input: RelatedViolationCardComponentInput;

    public title: string;
    public fields: ICardField[];

    constructor(
        private _labelsProviderPipe: LabelsProviderPipe,
        private _sidePanelService: SidePanelService,
    ) {}

    ngOnInit(): void {
        this.title = this.input.violationName;
        this.fields = [
            {
                key: this._labelsProviderPipe.transform("inventoryResourcePage.resourceViolationCardPolicyCategoryFieldKey"),
                value: this.input.ruleCategory,
            },
            {
                key: this._labelsProviderPipe.transform("inventoryResourcePage.resourceViolationCardFirstSeenFieldKey"),
                value: this.input.firstSeen,
            },
        ];
    }

    public openViolation() {
        this._sidePanelService.openViolationDetails(this.input.violationId, this.input.integrationId);
    }
}
